import * as React from "react";
/**
 * Trophy icon component for goal celebrations
 */ export const Trophy = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter0_i_2514_371939)"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.5546 6.83435C23.6549 6.58298 22.7198 7.10477 22.4606 8.00871C22.3287 8.46869 21.8489 8.73465 21.3889 8.60275C20.9289 8.47084 20.6629 7.99101 20.7948 7.53102C21.3144 5.71919 23.1917 4.66167 25.0082 5.16185C25.0421 5.17029 25.1102 5.18737 25.1717 5.20787C27.6647 6.03887 27.863 9.42172 25.6272 10.658C25.6271 10.6581 25.6273 10.6579 25.6272 10.658L20.6572 13.408C20.2385 13.6397 19.7112 13.4881 19.4796 13.0694C19.2479 12.6507 19.3995 12.1234 19.8182 11.8917L24.7882 9.14174C25.7702 8.59891 25.6112 7.1862 24.6293 6.85374L24.6232 6.85205C24.6122 6.84911 24.5989 6.84578 24.5776 6.84044C24.5699 6.83852 24.5622 6.83648 24.5546 6.83435Z",
        fill: "#FFD340"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.5546 6.83435C23.6549 6.58298 22.7198 7.10477 22.4606 8.00871C22.3287 8.46869 21.8489 8.73465 21.3889 8.60275C20.9289 8.47084 20.6629 7.99101 20.7948 7.53102C21.3144 5.71919 23.1917 4.66167 25.0082 5.16185C25.0421 5.17029 25.1102 5.18737 25.1717 5.20787C27.6647 6.03887 27.863 9.42172 25.6272 10.658C25.6271 10.6581 25.6273 10.6579 25.6272 10.658L20.6572 13.408C20.2385 13.6397 19.7112 13.4881 19.4796 13.0694C19.2479 12.6507 19.3995 12.1234 19.8182 11.8917L24.7882 9.14174C25.7702 8.59891 25.6112 7.1862 24.6293 6.85374L24.6232 6.85205C24.6122 6.84911 24.5989 6.84578 24.5776 6.84044C24.5699 6.83852 24.5622 6.83648 24.5546 6.83435Z",
        fill: "url(#paint0_linear_2514_371939)"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M24.5546 6.83435C23.6549 6.58298 22.7198 7.10477 22.4606 8.00871C22.3287 8.46869 21.8489 8.73465 21.3889 8.60275C20.9289 8.47084 20.6629 7.99101 20.7948 7.53102C21.3144 5.71919 23.1917 4.66167 25.0082 5.16185C25.0421 5.17029 25.1102 5.18737 25.1717 5.20787C27.6647 6.03887 27.863 9.42172 25.6272 10.658C25.6271 10.6581 25.6273 10.6579 25.6272 10.658L20.6572 13.408C20.2385 13.6397 19.7112 13.4881 19.4796 13.0694C19.2479 12.6507 19.3995 12.1234 19.8182 11.8917L24.7882 9.14174C25.7702 8.59891 25.6112 7.1862 24.6293 6.85374L24.6232 6.85205C24.6122 6.84911 24.5989 6.84578 24.5776 6.84044C24.5699 6.83852 24.5622 6.83648 24.5546 6.83435Z",
        fill: "url(#paint1_radial_2514_371939)"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter1_i_2514_371939)"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.30766 5.16184C8.12408 4.66168 10.0014 5.71919 10.521 7.53102C10.6529 7.99101 10.3869 8.47084 9.92695 8.60275C9.46696 8.73465 8.98714 8.46869 8.85523 8.00871C8.59601 7.10477 7.6609 6.58298 6.76127 6.83435C6.75363 6.83648 6.74595 6.83852 6.73825 6.84044C6.71688 6.84578 6.70366 6.84911 6.69264 6.85205L6.68649 6.85374C5.70461 7.1862 5.54534 8.59874 6.52731 9.14157L11.4976 11.8917C11.9163 12.1234 12.0679 12.6507 11.8363 13.0694C11.6046 13.4881 11.0773 13.6397 10.6586 13.408L5.68894 10.6582C5.68884 10.6581 5.68904 10.6582 5.68894 10.6582C3.4531 9.42189 3.65113 6.03887 6.14413 5.20787C6.20563 5.18737 6.27372 5.17029 6.30766 5.16184Z",
        fill: "#EAA73A"
    }), /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.30766 5.16184C8.12408 4.66168 10.0014 5.71919 10.521 7.53102C10.6529 7.99101 10.3869 8.47084 9.92695 8.60275C9.46696 8.73465 8.98714 8.46869 8.85523 8.00871C8.59601 7.10477 7.6609 6.58298 6.76127 6.83435C6.75363 6.83648 6.74595 6.83852 6.73825 6.84044C6.71688 6.84578 6.70366 6.84911 6.69264 6.85205L6.68649 6.85374C5.70461 7.1862 5.54534 8.59874 6.52731 9.14157L11.4976 11.8917C11.9163 12.1234 12.0679 12.6507 11.8363 13.0694C11.6046 13.4881 11.0773 13.6397 10.6586 13.408L5.68894 10.6582C5.68884 10.6581 5.68904 10.6582 5.68894 10.6582C3.4531 9.42189 3.65113 6.03887 6.14413 5.20787C6.20563 5.18737 6.27372 5.17029 6.30766 5.16184Z",
        fill: "url(#paint2_linear_2514_371939)"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter2_i_2514_371939)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M17.328 17.5198V13.2998H13.9879V17.5198C13.9879 18.2598 13.658 18.9698 13.088 19.4398L11.168 21.0398H20.1479L18.228 19.4398C17.658 18.9598 17.328 18.2598 17.328 17.5198Z",
        fill: "url(#paint3_linear_2514_371939)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M17.328 17.5198V13.2998H13.9879V17.5198C13.9879 18.2598 13.658 18.9698 13.088 19.4398L11.168 21.0398H20.1479L18.228 19.4398C17.658 18.9598 17.328 18.2598 17.328 17.5198Z",
        fill: "url(#paint4_radial_2514_371939)"
    })), /*#__PURE__*/ React.createElement("path", {
        d: "M17.328 17.5198V13.2998H13.9879V17.5198C13.9879 18.2598 13.658 18.9698 13.088 19.4398L11.168 21.0398H20.1479L18.228 19.4398C17.658 18.9598 17.328 18.2598 17.328 17.5198Z",
        fill: "url(#paint5_radial_2514_371939)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15.6575 16.55C11.8075 16.55 8.6875 13.43 8.6875 9.58V2.72C8.6875 2.33 9.00749 2.01001 9.39749 2.01001H21.9275C22.3175 2.01001 22.6375 2.33 22.6375 2.72V9.58C22.6375 13.43 19.5175 16.55 15.6575 16.55Z",
        fill: "#EA873A"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15.6575 16.55C11.8075 16.55 8.6875 13.43 8.6875 9.58V2.72C8.6875 2.33 9.00749 2.01001 9.39749 2.01001H21.9275C22.3175 2.01001 22.6375 2.33 22.6375 2.72V9.58C22.6375 13.43 19.5175 16.55 15.6575 16.55Z",
        fill: "url(#paint6_radial_2514_371939)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15.6575 16.55C11.8075 16.55 8.6875 13.43 8.6875 9.58V2.72C8.6875 2.33 9.00749 2.01001 9.39749 2.01001H21.9275C22.3175 2.01001 22.6375 2.33 22.6375 2.72V9.58C22.6375 13.43 19.5175 16.55 15.6575 16.55Z",
        fill: "url(#paint7_radial_2514_371939)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M15.6575 16.55C11.8075 16.55 8.6875 13.43 8.6875 9.58V2.72C8.6875 2.33 9.00749 2.01001 9.39749 2.01001H21.9275C22.3175 2.01001 22.6375 2.33 22.6375 2.72V9.58C22.6375 13.43 19.5175 16.55 15.6575 16.55Z",
        fill: "url(#paint8_radial_2514_371939)"
    }), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter3_i_2514_371939)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M22.5779 21.04H8.73785C8.00785 21.04 7.38786 21.55 7.24786 22.26L5.71786 29.35C5.64786 29.68 5.89785 29.99 6.23785 29.99H25.0879C25.4279 29.99 25.6779 29.68 25.6079 29.35L24.0779 22.26C23.9279 21.55 23.3079 21.04 22.5779 21.04Z",
        fill: "url(#paint9_linear_2514_371939)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22.5779 21.04H8.73785C8.00785 21.04 7.38786 21.55 7.24786 22.26L5.71786 29.35C5.64786 29.68 5.89785 29.99 6.23785 29.99H25.0879C25.4279 29.99 25.6779 29.68 25.6079 29.35L24.0779 22.26C23.9279 21.55 23.3079 21.04 22.5779 21.04Z",
        fill: "url(#paint10_linear_2514_371939)"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M22.5779 21.04H8.73785C8.00785 21.04 7.38786 21.55 7.24786 22.26L5.71786 29.35C5.64786 29.68 5.89785 29.99 6.23785 29.99H25.0879C25.4279 29.99 25.6779 29.68 25.6079 29.35L24.0779 22.26C23.9279 21.55 23.3079 21.04 22.5779 21.04Z",
        fill: "url(#paint11_linear_2514_371939)"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter4_f_2514_371939)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18.4022 23.884H12.3822C12.0322 23.884 11.7422 24.164 11.7422 24.524V26.334C11.7422 26.684 12.0222 26.974 12.3822 26.974H18.4022C18.7522 26.974 19.0422 26.694 19.0422 26.334V24.524C19.0422 24.174 18.7622 23.884 18.4022 23.884Z",
        fill: "#914556"
    })), /*#__PURE__*/ React.createElement("g", {
        filter: "url(#filter5_i_2514_371939)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M18.6678 23.7H12.6478C12.2978 23.7 12.0078 23.98 12.0078 24.34V26.15C12.0078 26.5 12.2878 26.79 12.6478 26.79H18.6678C19.0178 26.79 19.3078 26.51 19.3078 26.15V24.34C19.3078 23.99 19.0278 23.7 18.6678 23.7Z",
        fill: "url(#paint12_linear_2514_371939)"
    })), /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("filter", {
        id: "filter0_i_2514_371939",
        x: "19.3711",
        y: "4.78784",
        width: "7.81055",
        height: "8.72852",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: "-0.25"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: "0.25"
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: "-1",
        k3: "1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.937255 0 0 0 0 0.576471 0 0 0 0 0.247059 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_2514_371939"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "filter1_i_2514_371939",
        x: "4.13477",
        y: "4.78784",
        width: "7.80957",
        height: "8.72852",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dy: "-0.25"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: "0.25"
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: "-1",
        k3: "1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.854902 0 0 0 0 0.458824 0 0 0 0 0.286275 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_2514_371939"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "filter2_i_2514_371939",
        x: "11.168",
        y: "13.2998",
        width: "9.48047",
        height: "7.98999",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dx: "0.5",
        dy: "0.25"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: "0.25"
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: "-1",
        k3: "1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.843137 0 0 0 0 0.462745 0 0 0 0 0.215686 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_2514_371939"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "filter3_i_2514_371939",
        x: "5.70605",
        y: "21.04",
        width: "20.5641",
        height: "9.59995",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dx: "0.65",
        dy: "0.65"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: "0.375"
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: "-1",
        k3: "1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.509804 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_2514_371939"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "filter4_f_2514_371939",
        x: "11.3422",
        y: "23.484",
        width: "8.0998",
        height: "3.89009",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: "0.2",
        result: "effect1_foregroundBlur_2514_371939"
    })), /*#__PURE__*/ React.createElement("filter", {
        id: "filter5_i_2514_371939",
        x: "12.0078",
        y: "23.45",
        width: "7.5498",
        height: "3.34009",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, /*#__PURE__*/ React.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "BackgroundImageFix",
        result: "shape"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), /*#__PURE__*/ React.createElement("feOffset", {
        dx: "0.25",
        dy: "-0.25"
    }), /*#__PURE__*/ React.createElement("feGaussianBlur", {
        stdDeviation: "0.2"
    }), /*#__PURE__*/ React.createElement("feComposite", {
        in2: "hardAlpha",
        operator: "arithmetic",
        k2: "-1",
        k3: "1"
    }), /*#__PURE__*/ React.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0.941176 0 0 0 0 0.533333 0 0 0 0 0.333333 0 0 0 1 0"
    }), /*#__PURE__*/ React.createElement("feBlend", {
        mode: "normal",
        in2: "shape",
        result: "effect1_innerShadow_2514_371939"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint0_linear_2514_371939",
        x1: "22.2362",
        y1: "11.9441",
        x2: "25.8678",
        y2: "8.66776",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FEC551"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FEC551",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint1_radial_2514_371939",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(22.2757 8.9046) rotate(-21.5519) scale(5.05047 4.65227)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.72717",
        stopColor: "#FFEC6A",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FFEC6A"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint2_linear_2514_371939",
        x1: "9.56557",
        y1: "7.95724",
        x2: "7.07873",
        y2: "7.24671",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#D27840"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#D27840",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint3_linear_2514_371939",
        x1: "16.9536",
        y1: "19.7598",
        x2: "11.8911",
        y2: "19.7598",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FBC33A"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#DB7B3C"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint4_radial_2514_371939",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(17.2348 17.1698) rotate(90) scale(2.09 1.90625)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.192585",
        stopColor: "#FFE469"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FFE469",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint5_radial_2514_371939",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(19.3915 20.3522) rotate(149.162) scale(2.27493 3.45405)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFD34D"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FFD34D",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint6_radial_2514_371939",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(18.2031 3.13501) rotate(83.702) scale(12.4237 7.97758)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.120527",
        stopColor: "#FFFA73"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FFFA73",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint7_radial_2514_371939",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(18.2832 2.01001) rotate(90) scale(0.704335 7.87152)"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFF45B"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FFF45B",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint8_radial_2514_371939",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(19.0156 4.76001) rotate(121.572) scale(13.1311 12.5983)"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0.787409",
        stopColor: "#C55D73",
        stopOpacity: "0"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#C55D73"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint9_linear_2514_371939",
        x1: "5.70576",
        y1: "25.5122",
        x2: "25.6158",
        y2: "25.5122",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#9D5B6C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#955569"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint10_linear_2514_371939",
        x1: "15.6629",
        y1: "30.3787",
        x2: "15.6629",
        y2: "28.7525",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#8C3A79"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#8C3A79",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint11_linear_2514_371939",
        x1: "24.8704",
        y1: "26.532",
        x2: "23.9322",
        y2: "26.751",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#B0817C"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#B0817C",
        stopOpacity: "0"
    })), /*#__PURE__*/ React.createElement("linearGradient", {
        id: "paint12_linear_2514_371939",
        x1: "19.6822",
        y1: "25.245",
        x2: "12.0078",
        y2: "25.2449",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FFE767"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "1",
        stopColor: "#FEBB5B"
    }))));
